export default __webpack_public_path__ + "static/media/599.6d8ae42e.gif";